import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    asyncAddTemplateTest,
    changeSuccessAddTemplateTest,
} from './add-template-test.actions';

import AddTemplateTestPresentation from './add-template-test-presentation';

class AddTemplateTest extends Component {
    constructor(props) {
        super(props);

        this.state = {
            labelTest: '',
            typeTest: '',
            maxDuration: 5,
            amountQuestion: 1,
            minOptions: 2,
            maxOptions: 2,
            percentual: 0,
            createNewTest: false,
            formReady: false,
            showQuestions: false,
            questionsAddeds: [],
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            labelTest,
            typeTest,
            maxDuration,
            minOptions,
            maxOptions,
            percentual,
            amountQuestion,
        } = this.state;
        const { successAddTemplate, changeSuccessAddTemplateTest } = this.props;

        if (
            prevProps.successAddTemplate !== successAddTemplate &&
            successAddTemplate
        ) {
            this.setState({
                labelTest: '',
                typeTest: '',
                maxDuration: 5,
                minOptions: 2,
                maxOptions: 2,
                percentual: 0,
                createNewTest: false,
                formReady: false,
                showQuestions: false,
                questionsAddeds: [],
                amountQuestion: 1,
            });
            changeSuccessAddTemplateTest(false);
        }

        if (
            prevState.labelTest !== labelTest ||
            prevState.typeTest !== typeTest ||
            prevState.maxDuration !== maxDuration ||
            prevState.minOptions !== minOptions ||
            prevState.maxOptions !== maxOptions ||
            prevState.amountQuestion !== amountQuestion ||
            prevState.percentual !== percentual
        ) {
            this.checkForm();
        }
    }

    handleChangeInput(target) {
        this.setState({ [target.name]: target.value });
    }

    checkForm() {
        const {
            labelTest,
            typeTest,
            maxDuration,
            minOptions,
            maxOptions,
            percentual,
            amountQuestion,
        } = this.state;

        const formIsOk =
            labelTest !== '' &&
            typeTest !== '' &&
            Number(maxDuration) >= 5 &&
            Number(maxDuration) <= 480 &&
            Number(amountQuestion) >= 1 &&
            Number(amountQuestion) <= 256 &&
            Number(maxOptions) >= 2 &&
            Number(maxOptions) <= 20 &&
            Number(minOptions) >= 2 &&
            Number(minOptions) <= Number(maxOptions) &&
            Number(percentual) > 0 &&
            Number(percentual) <= 100;
        this.setState({ formReady: formIsOk });
    }

    handleSubmit(ev) {
        ev.preventDefault();

        const {
            labelTest,
            typeTest,
            maxDuration,
            minOptions,
            maxOptions,
            percentual,
            createNewTest,
            questionsAddeds,
            amountQuestion,
        } = this.state;
        const { asyncAddTemplateTest } = this.props;

        const maxDurationInSeconds = maxDuration * 60;
        asyncAddTemplateTest({
            labelTest,
            typeTest,
            maxDuration: maxDurationInSeconds,
            minOptions,
            maxOptions,
            percentual,
            createNewTest,
            amountQuestions: amountQuestion,
            questions: questionsAddeds,
        });
    }

    handleShowQuestions(current) {
        this.setState({ showQuestions: !current });
    }

    handleHandleQuestionsAdd(newQuestionsAddeds) {
        this.setState({ questionsAddeds: newQuestionsAddeds });
    }

    checkDisableQuestionFn(question) {
        const { minOptions, maxOptions } = this.state;
        let questionDisabled = false;
        const amountEnabledItems = question.options.filter(
            option => option.enabled,
        ).length;
        if (
            !questionDisabled &&
            (amountEnabledItems < minOptions || amountEnabledItems > maxOptions)
        ) {
            questionDisabled = true;
        }

        return questionDisabled;
    }

    render() {
        const {
            labelTest,
            typeTest,
            maxDuration,
            minOptions,
            maxOptions,
            percentual,
            createNewTest,
            formReady,
            showQuestions,
            questionsAddeds,
            amountQuestion,
        } = this.state;
        const { loading } = this.props;

        return (
            <AddTemplateTestPresentation
                labelTest={labelTest}
                typeTest={typeTest}
                maxDuration={maxDuration}
                minOptions={minOptions}
                maxOptions={maxOptions}
                amountQuestion={amountQuestion}
                percentual={percentual}
                formReady={formReady}
                createNewTest={createNewTest}
                handleChangeInput={this.handleChangeInput.bind(this)}
                handleSubmit={this.handleSubmit.bind(this)}
                loading={loading}
                showQuestions={showQuestions}
                handleShowQuestions={this.handleShowQuestions.bind(this)}
                handleHandleQuestionsAdd={this.handleHandleQuestionsAdd.bind(
                    this,
                )}
                questionsAddeds={questionsAddeds}
                checkDisableQuestionFn={this.checkDisableQuestionFn.bind(this)}
            />
        );
    }
}

// eslint-disable-next-line no-unused-vars
const mapStateToProps = ({ addTemplateTest, onlineTests }) => ({
    successAddTemplate: addTemplateTest.successAddTemplate,
    loading: onlineTests.loading,
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            asyncAddTemplateTest,
            changeSuccessAddTemplateTest,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(AddTemplateTest);



// WEBPACK FOOTER //
// ./src/components/add-template-test/add-template-test.js